<section>

    <img src="assets/images/Logo-FONA.jpeg" alt="Banner SSR" class="img-fluid max-width: 20% height: 20% ">

    <div class="container py-4">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="row  align-items-end">
                    <div class="col-12 text-center pb-5">
                        <h2 class="text-dark  p-3 d-inline-block">
                            <a href="/" class="text-decoration-none text-primary">Inicio</a> - FONA
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="container py-2">
    <div class="row g-4 mb-5" id="motivacion">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Motivación</h3>
                <hr>
                <p>Una de las partes fundamentales del desarrollo en la educación de una persona es el habla, ya que la
                    misma permite expresar diferentes sentimientos y más aún una manera de manejar de mejor forma cierta
                    información con la finalidad de adquirir un conocimiento.</p>
            </div>
        </div>

        <div class="egames-video-area col-md-6 animate-box fadeInUp animated-fast">
            <div class="ratio ratio-16x9">
                <video controls poster="assets/images/4.png">
                    <source src="videos/ssr/Intro.mp4" type="video/mp4">
                </video>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row py-lg-5" id="problematica">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Problemática</h3>
                <hr class="my-3">
                <p>Con lo antes mencionado según la UNICEF un número importante de niños con trastornos de la
                    comunicación
                    no tienen acceso a servicios adecuados de educación especial o atención médica. Del mismo modo, en
                    la
                    actualidad existe la deficiencia de servicios importantes como el uso de la tecnología para los
                    niños
                    con discapacidades en áreas como la terapia del habla y del lenguaje, la fisioterapia y la enseñanza
                    del
                    lenguaje de señas (Ochoa-Guaraca, M., Carpio-Moreta, M., Serpa-Andrade, L., Robles-Bykbaev, V.,
                    Lopez-Nores, M., &amp; Duque, n.d.)</p>
            </div>
        </div>

        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="accordion" id="dislaliaAccordion">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Dislalia en estadísticas
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                        data-bs-parent="#dislaliaAccordion">
                        <div class="accordion-body">
                            <p>Internacionalmente se han hecho estudios acerca de la dislalia encontrando un 42% en
                                niños de
                                4 a 6 años como se reporta en la ciudad de México, en Cuba fue 24%. En Buenos Aires fue
                                5.8%, y en Chile es el 13.9%. En la ciudad Quito- Ecuador se encontró 12.3% y en la
                                ciudad
                                de Cuenca Ecuador un 8.4 % (Calderon Cango, Christian Stalin. Quizhpi Arichábala, Luis
                                Armando. Medina Valenzuela, 2012).</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row py-lg-5" id="propuesta">
        <div class="col-12 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Propuesta</h3>
                <hr class="my-3">
                <p class="mb-0">El proyecto FONA tiene como finalidad el brindar terapia de lenguaje a aquellos niños y
                    niñas que padecen trastornos de la comunicación especialmente en edades correspondidas entre 3 y 6
                    años. A continuación en la figura 1, se describe los módulos más relevantes y sus funcionalidades.
                </p>
            </div>
        </div>
    </div>
</section>


<section class="container py-2">
    <!-- Imagen Fig.1 -->
    <div class="row mb-5">
        <div class="col-12 text-center">

            <img src="assets/images/Picture11.png" alt="Simply Easy Learning" class="img-fluid"
                style="max-width: 800px;">
            <p class="mt-3"><strong>Fig.1</strong> Arquitectura general del sistema propuesto, sus principales
                componentes y módulos (Robles et al., 2018)</p>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row py-lg-5">
        <div class="col-12 animate-box fadeInUp animated-fast">
            <div class="accordion" id="accordionExample">
                <!-- Item 1 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                            Capa de interfaz de usuario:
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <p>En esta capa el niño podrá interactuar con el asistente robótico llamado FONA, siendo
                                capaz de proporcionar estímulos
                                táctiles, auditivos y visuales durante las sesiones de terapia del habla y lenguaje
                                (Robles et al., 2018).</p>
                        </div>
                    </div>
                </div>

                <!-- Item 2 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Capa de conocimiento:
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <p>Encargado de sugerir actividades de intervención lo logra mediante un módulo de
                                razonamiento basado en reglas que
                                representa a través de los hechos y rige las pautas de intervención. El generador de
                                planes de terapia utiliza el módulo
                                de razonamiento para armar un plan de intervención con ejercicios sugeridos de acuerdo
                                con el perfil del niño. De la
                                misma manera, el generador de planes utiliza el módulo de los scripts de interacción del
                                robot para establecer cómo será
                                la interacción con los niños (Robles et al., 2018).</p>
                        </div>
                    </div>
                </div>

                <!-- Item 3 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                            La capa servicios y datos:
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <p>Se encarga de almacenar los perfiles de los pacientes, con los siguientes datos:
                                información personal del niño (nombre,
                                edad, sexo, etc.) y perfil médico (evaluación inicial y diagnóstico de la TSL). Otros
                                elementos esenciales de esta capa
                                son el servicio para monitorear el progreso del paciente y generar informes y un módulo
                                de retroalimentación que se
                                implementará en el futuro para recopilar una evaluación (realizada por los SLT) de los
                                planes de terapia creados por el
                                sistema (Robles et al., 2018).</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row py-lg-5 pt-5" id="resultados">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="text-center pt-5">
                <img class="img-fluid mx-auto d-block" src="assets/images/beneficiariosFona.png"
                    alt="Resultados de encuesta sobre FONA" width="400">
                <div class="mt-3">
                    <p class="mb-0"><strong>Fig.2</strong> Beneficiarios directos provincia Azuay - Ecuador.</p>
                </div>
            </div>
        </div>

        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Resultados</h3>
                <hr class="my-3">
                <p>El total de beneficiarios del proyecto FONA en la provincia del Azuay que asisten a los CDEI (Centro
                    de Educación
                    Inicial) particulares es de 1064 niñas y 1065 niños, mientras que en los Centros públicos es de 1179
                    niñas y 1212 niños
                    con edades comprendidas entre 3 a 6 años.</p>


            </div>

            <h6 class="my-3">Población Beneficiaria Indirecta
            </h6>

            <p class="mb-3">Por otro lado, el número de beneficiarios a nivel del Ecuador que asisten a los CDEI
                particulares es de 112088 niñas y
                111488 niños, y en los Centros públicos es de 387898 niñas y 389697 niños con edades comprendidas entre
                3 a 6 años.
            </p>
        </div>
    </div>
</section>

<section class="container py-2">

    <div class="row mb-5">
        <div class="col-12 text-center">
            <img src="assets/images/beneficiariosIndiFona.png" alt="Simply Easy Learning"
                class="img-fluid" style="max-width: 800px;">
            <p class="mt-3"><strong>Fig.3</strong>Beneficarios Directos e Indirectos FONA</p>
        </div>
    </div>
</section>

<section class="container py-2">


    <div class="row g-4 py-lg-5">
        <div class="col-md-12 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <div id="colorlib-project">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8 text-center animate-box fadeInUp animated-fast">
                                <h3 class="mb-3">Interacción con el asistente robótico</h3>
                                <p class="mb-5">Pruebas realizadas en la Unidad Educativa "Sor Teresa Valsé" con
                                    niñas de cinco a seis años de edad en las áreas de cuidado personal y las partes del
                                    cuerpo.</p>
                            </div>
                        </div>

                        <!-- Image Gallery -->
                        <div class="row g-4">
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofona/1.jpeg"
                                    alt="Interacción con FONA 1" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="./Mesade - Pilar 3Felpudo_files/1.png">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofona/2.jpg"
                                    alt="Interacción con FONA 2" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofona/2.jpg">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofona/3.jpg"
                                    alt="Interacción con FONA 3" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofona/3.jpg">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofona/4.jpg"
                                    alt="Interacción con FONA 4" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofona/4.jpg">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofona/5.jpg"
                                    alt="Interacción con FONA 5" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofona/5.jpg">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofona/6.jpeg"
                                    alt="Interacción con FONA 6" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofona/6.jpeg">
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="my-5">

                <h4 class="mb-4">Para desarrolladores:</h4>
                <!-- Optional link can be added here -->
            </div>
        </div>
    </div>
</section>
<section class="container py-2">

    <!-- Single Modal for all images -->
    <div class="modal fade" id="imageModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                    <img id="modalImage" class="img-fluid" src="" alt="">
                </div>
            </div>
        </div>
    </div>

    <!-- Team Section -->
    <div class="row mb-5" id="equipo">
        <div class="col-12 text-center mb-5 animate__animated animate__fadeInUp">
            <h2>Equipo</h2>
        </div>
    </div>  
    <div class="row mb-5" id="equipo">
        <!-- Team Member 1 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/psuquilanda.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Paola Suquilanda</h5>
                    <p class="card-text">Bachelor of Basic Education (Educational Unit Saint Mariana de Jesús)</p>
                </div>
            </div>
        </div>

        <!-- Team Member 2 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Liliana Matute</h5>
                    <p class="card-text">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>

        <!-- Team Member 3 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/kpanama.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Karina Panamá Manzheda</h3>
                    <p class="mb-1">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>

        <!-- Team Member 4 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/vrobles.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Vladimir Robles Bykbaev</h5>
                    <p class="mb-1">Doctor PH.D</p>
                    <p class="small">Doctor en Tecnologías de la información y las comunicaciones.</p>
                </div>
            </div>
        </div>

        <!-- Team Member 5 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/elema.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Efrén Lema Condo</h5>
                    <p class="card-text">Ingeniero Electrónico</p>
                </div>
            </div>
        </div>

        <!-- Team Member 6 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Carlos Contreras</h5>
                    <p class="card-text">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>
    </div>
</section>